import axios from 'axios';

import environment from 'environment';
import { getSessionTokenHeader } from '../util/util';

/**
 * @returns {object}
 * @param allMessages
 * @param subject
 * @param simplrAccountObjectId
 * @param customerPtrId
 * @param selectedTicket
 */
export const getOrdersIdsMentionedInTicket = async (
  allMessages,
  subject,
  simplrAccountObjectId,
  customerPtrId,
  selectedTicket
) => {
  const requestParams = {
    message: allMessages,
    businessId: simplrAccountObjectId,
    customerId: customerPtrId,
    subject,
    brandName: selectedTicket && selectedTicket.brand,
  };
  const sessionTokenHeader = await getSessionTokenHeader();
  const requestConfig = { headers: sessionTokenHeader };
  const response = await axios.post(environment.services.whatOrderMlUrl, requestParams, requestConfig);

  return response.data;
};
